import { Action } from '../../../action';
import { DefaultApi } from "../../../api";
import { getCatchError } from '../../../getCatchError';
import { urls } from "../../../urls";

const setGetGroups = (params) => {
    return async (dispatch, getState) => {
        try {
            const { data } = await DefaultApi({
                params,
                method: 'get',
                url: urls.GET_GROUPS_CASHIERS
            });

            if (data.status === 'success') {
                dispatch(Action.SetGetGroupsAction(data.groups));
            }


        } catch (error) {
            getCatchError(error)
        }
    }
}

export {
    setGetGroups as SetGetGroups
}